import { ITrial, ResponseStatus } from "@/api/dtos";
import { createContext } from "react"

export interface ITrialContext {
    data?: ITrial;
    code?: string;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<ITrial | undefined>
}

export const TrialContext = createContext<ITrialContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<ITrial | undefined>(res => {
            res(undefined);
        });
    }
});

export default TrialContext;